import { render, staticRenderFns } from "./CityTag.vue?vue&type=template&id=61c8d98e&"
import script from "./CityTag.vue?vue&type=script&lang=js&"
export * from "./CityTag.vue?vue&type=script&lang=js&"
import style0 from "./CityTag.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports